(function () {
  'use strict';

  const { gsap } = window;
  const { iman, BaseCarousel, layout } = window.Universe;

  class ReviewsCarousels {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.sections.length; i++) {
        this.carousels.push(new ReviewsCarousel(this.DOM.sections[i]));
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      this.destroySection(sectionEl);
      if (!this.DOM) {
        this.DOM = {};
        this.carousels = [];
      }
      const newSections = sectionEl.querySelectorAll('.js-reviews-carousel-section');
      for (let i = 0; i < newSections.length; i++) {
        this.carousels.push(new ReviewsCarousel(newSections[i]));
      }
      this.DOM.sections = document.querySelectorAll('.js-reviews-carousel-section');
    }

    destroySection(sectionEl) {
      if (!this.carousels) return;
      const targetId = sectionEl.id || sectionEl.closest('.shopify-section')?.id;
      if (!targetId) return;
      for (let i = this.carousels.length - 1; i >= 0; i--) {
        const item = this.carousels[i];
        if (item.sectionId === targetId) {
          item.destroy();
          this.carousels.splice(i, 1);
        }
      }
    }

    onBlockSelect(blockEl) {
      for (let i = 0; i < this.carousels.length; i++) {
        const item = this.carousels[i];
        if (item.DOM && item.DOM.section && item.DOM.section.contains(blockEl)) {
          const slide = blockEl.closest('.js-reviews-carousel-slide');
          if (!slide) break;

          const emblaApi = item.instance ? item.instance.instance : null;
          if (emblaApi) {
            const slides = emblaApi.slideNodes();
            const slideIndex = Array.from(slides).indexOf(slide);
            if (slideIndex !== -1) {
              const autoplay = emblaApi.plugins().autoplay;
              if (autoplay) autoplay.stop();
              emblaApi.scrollTo(slideIndex);
            }
          }
          break;
        }
      }
    }

    onBlockDeselect(blockEl) {
      for (let i = 0; i < this.carousels.length; i++) {
        const item = this.carousels[i];
        if (item.DOM && item.DOM.section && item.DOM.section.contains(blockEl)) {
          const emblaApi = item.instance ? item.instance.instance : null;
          if (emblaApi) {
            const autoplay = emblaApi.plugins().autoplay;
            if (autoplay) autoplay.play();
          }
          break;
        }
      }
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.carousels.length; i++) {
          this.carousels[i].destroy();
        }
        this.carousels = [];
        this.DOM = undefined;
      }
    }

    init(container) {
      if (!container) container = document;
      const sections = container.querySelectorAll('.js-reviews-carousel-section');

      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;

        this.carousels = [];

        this.setup();
      }
    }
  }

  class ReviewsCarousel {
    constructor(section) {
      this.onChangeSlide = () => {
        const prevIndicator = this.DOM.indicators[this.activeIndex];
        const prevIndicatorInner = prevIndicator.querySelector('.js-reviews-carousel-indicator-inner');
        if (this.progressTl) {
          this.progressTl.kill();
        }

        if (this.hasAutoplay) {
          gsap.killTweensOf(prevIndicatorInner);

          gsap.to(prevIndicatorInner, {
            duration: 0.3,
            scaleX: 1,
            opacity: 0,
            ease: 'linear',
            onComplete: () => {
              prevIndicatorInner.style.transform = 'scaleX(0)';
              prevIndicatorInner.style.opacity = '1';
            },
          });
          this.stopAutoPlay();
        }

        const nextIndex = this.instance.instance.selectedScrollSnap();

        gsap.killTweensOf(this.DOM.indexes);
        gsap.to(this.DOM.indexes, {
          duration: 0.4,
          y: 0,
          yPercent: (i) => {
            return 100 * (i - nextIndex);
          },
        });

        this.activeIndex = nextIndex;

        if (this.hasAutoplay) {
          this.setupAutoPlayProgress();
        }
        const activeIndicator = this.DOM.indicators[this.activeIndex];
        const activeIndicatorInner = activeIndicator.querySelector('.js-reviews-carousel-indicator-inner');
        gsap.killTweensOf(activeIndicatorInner);

        if (this.hasAutoplay) {
          this.progressTl.to(activeIndicatorInner, {
            duration: this.autoplayDelay,
            ease: 'linear',
            scaleX: 1,
          });
        }

        this.updateMobileSlides();
        this.updateIndicators();
        this.updateButtonStates();

        // Announce slide change to screen readers
        this.announceSlideChange();

        if (this.hasAutoplay) {
          this.progressTl.play();
          this.startAutoPlay();
        }
      };

      this.onPrev = () => {
        this.instance.instance.scrollPrev();
      };

      this.onNext = () => {
        this.instance.instance.scrollNext();
      };

      this.handleKeyDown = (e) => {
        const isOnIndicator = e.target.classList.contains('js-reviews-carousel-indicator');
        if (isOnIndicator) return;

        switch (e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            this.instance.instance.scrollPrev();
            break;
          case 'ArrowRight':
            e.preventDefault();
            this.instance.instance.scrollNext();
            break;
          case 'Home':
            e.preventDefault();
            this.instance.instance.scrollTo(0);
            break;
          case 'End':
            e.preventDefault();
            const lastIndex = this.instance.instance.scrollSnapList().length - 1;
            this.instance.instance.scrollTo(lastIndex);
            break;
        }
      };

      if (section) {
        this.init(section);
      }
    }

    setup() {
      this.hasAutoplay = this.DOM.section.getAttribute('data-autoplay') === '';
      this.autoplayDelay = Number(this.DOM.section.getAttribute('data-autoplay-delay')) || 4;

      this.instance = new BaseCarousel({
        wrap: this.DOM.section,
        carouselOptions: {
          breakpoints: {
            '(min-width: 1024px)': {
              align: 'center',
              containScroll: false,
              inViewThreshold: 0.7,
              watchDrag: false,
            },
            '(max-width: 1023px)': {
              align: 'center',
              containScroll: false,
              inViewThreshold: 1,
              watchDrag: true,
            },
            '(max-width: 767px)': {
              align: 'center',
              containScroll: 'trimSnaps',
              inViewThreshold: 1,
              watchDrag: true,
            },
          },
        },
        autoPlayOnInit: false,
        withAutoPlay: this.hasAutoplay,
        autoPlayDelay: this.autoplayDelay * 1000,
        onReady: () => {
          this.setupIndexes();
          this.updateMobileSlides();
          this.updateIndicators();
          this.setupTabIndicators();

          this.instance.instance.on('select', this.onChangeSlide);

          if (this.DOM.prev.length) {
            for (let i = 0; i < this.DOM.prev.length; i++) {
              this.DOM.prev[i].addEventListener('click', this.onPrev);
            }
          }

          if (this.DOM.next.length) {
            for (let i = 0; i < this.DOM.next.length; i++) {
              this.DOM.next[i].addEventListener('click', this.onNext);
            }
          }

          if (this.hasAutoplay) {
            this.setupAutoPlayProgress();
            this.startAutoPlay();

            const activeIndicator = this.DOM.indicators[this.activeIndex];
            const activeIndicatorInner = activeIndicator.querySelector('.js-reviews-carousel-indicator-inner');
            this.progressTl.to(activeIndicatorInner, {
              duration: this.autoplayDelay,
              ease: 'linear',
              scaleX: 1,
            });
            this.progressTl.play();
          }

          // Add global keyboard navigation for carousel
          this.DOM.viewport = this.DOM.section.querySelector('.js-carousel');
          if (this.DOM.viewport) {
            this.DOM.viewport.addEventListener('keydown', this.handleKeyDown);
          }

          this.updateButtonStates();
        },
      });
    }

    updateButtonStates() {
      if (!this.instance || !this.instance.instance) return;

      const canScrollPrev = this.instance.instance.canScrollPrev();
      const canScrollNext = this.instance.instance.canScrollNext();

      if (this.DOM.prev.length) {
        for (let i = 0; i < this.DOM.prev.length; i++) {
          this.DOM.prev[i].removeAttribute('disabled');
          this.DOM.prev[i].setAttribute('aria-disabled', !canScrollPrev);
        }
      }

      if (this.DOM.next.length) {
        for (let i = 0; i < this.DOM.next.length; i++) {
          this.DOM.next[i].removeAttribute('disabled');
          this.DOM.next[i].setAttribute('aria-disabled', !canScrollNext);
        }
      }
    }

    setupAutoPlayProgress() {
      this.progressTl = gsap.timeline({
        paused: true,
      });
    }

    setupIndexes() {
      // Initial positioning handled by CSS via --i custom property
    }

    updateMobileSlides() {
      if (layout.device < 1) {
        for (let i = 0; i < this.DOM.slides.length; i++) {
          this.DOM.slides[i].classList.toggle('is-mobile-active', i === this.activeIndex);
        }
      }
    }

    updateIndicators() {
      if (layout.device < 1) {
        for (let i = 0; i < this.DOM.indicators.length; i++) {
          const isActive = i === this.activeIndex;
          this.DOM.indicators[i].classList.toggle('is-active', isActive);
          this.DOM.indicators[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
          this.DOM.indicators[i].setAttribute('tabindex', isActive ? '0' : '-1');
        }
      }
    }

    setupTabIndicators() {
      if (!this.DOM.indicators.length) return;

      for (let idx = 0; idx < this.DOM.indicators.length; idx++) {
        ((index) => {
          const indicator = this.DOM.indicators[index];
          const isActive = index === this.activeIndex;
          indicator.setAttribute('tabindex', isActive ? '0' : '-1');
          indicator.setAttribute('aria-selected', isActive ? 'true' : 'false');

          // Click handler
          indicator.addEventListener('click', () => {
            this.goToSlide(index);
          });

          // Keyboard handler
          indicator.addEventListener('keydown', (e) => {
            let targetIndex = null;

            switch (e.key) {
              case 'ArrowLeft':
              case 'ArrowUp':
                e.preventDefault();
                targetIndex = index > 0 ? index - 1 : this.DOM.indicators.length - 1;
                break;
              case 'ArrowRight':
              case 'ArrowDown':
                e.preventDefault();
                targetIndex = index < this.DOM.indicators.length - 1 ? index + 1 : 0;
                break;
              case 'Home':
                e.preventDefault();
                targetIndex = 0;
                break;
              case 'End':
                e.preventDefault();
                targetIndex = this.DOM.indicators.length - 1;
                break;
              default:
                return;
            }

            if (targetIndex !== null) {
              this.DOM.indicators[targetIndex].focus();
              this.goToSlide(targetIndex);
            }
          });
        })(idx);
      }
    }

    goToSlide(index) {
      if (this.instance && this.instance.instance) {
        this.instance.instance.scrollTo(index);
      }
    }

    announceSlideChange() {
      if (!this.DOM.announcement) return;

      const currentSlide = this.activeIndex;
      const totalSlides = this.DOM.slides.length;
      const template = window.reviewsCarouselStrings?.reviewAnnouncement || 'Showing review [current] of [total]';
      this.DOM.announcement.textContent = template.replace('[current]', currentSlide + 1).replace('[total]', totalSlides);
    }

    stopAutoPlay() {
      const plugins =
        this.instance.instance && this.instance.instance.plugins ? this.instance.instance.plugins() : null;
      const autoplay = plugins ? plugins.autoplay : null;
      if (autoplay) {
        autoplay.stop();
      }
    }

    startAutoPlay() {
      const plugins =
        this.instance.instance && this.instance.instance.plugins ? this.instance.instance.plugins() : null;
      const autoplay = plugins ? plugins.autoplay : null;
      if (autoplay) {
        autoplay.play();
      }
    }

    destroy() {
      if (this.DOM) {
        if (this.DOM.prev.length) {
          for (let i = 0; i < this.DOM.prev.length; i++) {
            this.DOM.prev[i].removeEventListener('click', this.onPrev);
          }
        }

        if (this.DOM.next.length) {
          for (let i = 0; i < this.DOM.next.length; i++) {
            this.DOM.next[i].removeEventListener('click', this.onNext);
          }
        }

        // Remove global keyboard listener
        if (this.DOM.viewport) {
          this.DOM.viewport.removeEventListener('keydown', this.handleKeyDown);
        }

        this.stopAutoPlay();
        if (this.instance) this.instance.destroy();

        this.instance = undefined;
        this.DOM = undefined;
      }
    }

    init(section) {
      this.DOM = {};
      this.DOM.section = section;
      this.sectionId = this.DOM.section.closest('.shopify-section')?.id || null;
      this.DOM.slides = this.DOM.section.querySelectorAll('.js-reviews-carousel-slide');
      this.DOM.indexes = this.DOM.section.querySelectorAll('.js-reviews-carousel-index');
      this.DOM.indicators = this.DOM.section.querySelectorAll('.js-reviews-carousel-indicator');
      this.DOM.indicatorsInner = this.DOM.section.querySelectorAll('.js-reviews-carousel-indicator-inner');
      this.DOM.prev = this.DOM.section.querySelectorAll('.js-carousel-prev');
      this.DOM.next = this.DOM.section.querySelectorAll('.js-carousel-next');
      this.DOM.announcement = this.DOM.section.querySelector('.js-carousel-announcement');

      this.activeIndex = 0;

      this.setup();
    }
  }

  function init() {
    if (!iman.get('reviewsCarousels')) {
      iman.add('reviewsCarousels', new ReviewsCarousels());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.ReviewsCarousels = ReviewsCarousels;
})();
